export enum KeySuffixOptions {
  Auto = "auto",
  Pin = "pin",
}
